import { Hero } from '../components/Hero';
import { ServicesGrid } from '../components/ServicesGrid';
import { Testimonials } from '../components/Testimonials';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <ServicesGrid />
      <Testimonials />
      <FAQSection />
      <CTASection />
    </main>
  );
}
